import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { array, object, string } from "prop-types";

import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import Row1 from "./Row1";
import Row2LeftColumn from "./Row2LeftColumn";
import Row2RightColumn from "./Row2RightColumn";
import DfpAd from "../../dfp-ad";

import { getCollectionName, getSlug } from "../../utils/utils";

import "./fourteenStories3Ad1Widget.m.css";

const FourteenStories3Ad1Widget = ({ collection, sections, domainSlug, publisherAttributes }) => {
  const stories =
    collection.items && collection.items.length > 0 && collection.items.filter((item) => item.type === "story");

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const adSlotId1 = get(collection, ["associated-metadata", "ad_slot_id1"], "epaper-fixed-banner");
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");
  const adSlotId3 = get(collection, ["associated-metadata", "ad_slot_id3"], "default_ad_slot3");
  const widgetUrl = get(collection, ["associated-metadata", "widget_url"], null);
  const showSectionTag = get(collection, ["associated-metadata", "show_section_tag"], null);
  const selectedTagName = get(collection, ["associated-metadata", "tag_name"], null);
  const headlineSpecialColor = get(collection, ["associated-metadata", "color"], null);

  if (!stories.length) {
    return null;
  }

  let newsSectionArray = {};

  if (publisherAttributes.lang === "bn") {
    newsSectionArray = {
      latestNews: { name: "সর্বশেষ সংবাদ", link: "/collection/latest" },
      specialNews: { name: "বিশেষ সংবাদ", link: "/topic/বিশেষ-সংবাদ" },
      opinionNews: { name: "মতামত", link: "/opinion" },
      coronaVirusNews: { name: "করোনাভাইরাস", link: "/topic/করোনাভাইরাস" },
      businessNews: { name: "বাণিজ্য", link: "/business" },
      entertainmentNews: { name: "বিনোদন", link: "/entertainment" },
      sportsNews: { name: "খেলা", link: "/sports" },
      videoNews: { name: "ভিডিও", link: "/video" },
    };
  } else {
    newsSectionArray = {
      latestNews: { name: "Latest", link: "/collection/latest" },
      specialNews: { name: "Exclusive", link: "/collection/exclusive" },
      opinionNews: { name: "Opinion", link: "/opinion" },
      coronaVirusNews: { name: "Coronavirus", link: "/topic/coronavirus" },
      businessNews: { name: "Business", link: "/business" },
      entertainmentNews: { name: "Entertainment", link: "/entertainment" },
      sportsNews: { name: "Sports", link: "/sports" },
      videoNews: { name: "Video", link: "/video" },
    };
  }

  return stories.length > 1 ? (
    <div styleName="base">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionSlug={collectionSlug} collectionName={collectionName} updatedFont={true} />
      )}
      <div styleName="wrapper">
        <Row1
          stories={stories.slice(0, 2)}
          collectionSlug={collectionSlug}
          adSlotId2={adSlotId2}
          newsSectionArray={newsSectionArray}
          widgetUrl={widgetUrl}
          showSectionTag={showSectionTag}
          selectedTagName={selectedTagName}
          headlineSpecialColor={headlineSpecialColor}
        />
        <Row2LeftColumn
          stories={stories.slice(2, 11)}
          newsSectionArray={newsSectionArray}
          showSectionTag={showSectionTag}
          selectedTagName={selectedTagName}
          headlineSpecialColor={headlineSpecialColor}
        />
        <Row2RightColumn
          stories={stories.slice(11, 13)}
          newsSectionArray={newsSectionArray}
          showSectionTag={showSectionTag}
          adSlotId1={adSlotId1}
          selectedTagName={selectedTagName}
          headlineSpecialColor={headlineSpecialColor}
        />
      </div>
      <div styleName="b1_ad">
        <div styleName="inner_ads">
          <DfpAd
            adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_468x60_B1" : "Home_468x60_B1"}
            collectionSlug={collectionSlug}
            layoutName="HomeFeatured"
            slotId={adSlotId3}
          />
        </div>
      </div>
    </div>
  ) : null;
};

FourteenStories3Ad1Widget.propTypes = {
  collection: object.isRequired,
  sections: array,
  domainSlug: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(FourteenStories3Ad1Widget);
